import * as workerTimers from 'worker-timers';

const func = $clock => {
	window.loader.key('moment', function() {
		var time = moment()
			.hours($clock.attr('data-hours'))
			.minutes($clock.attr('data-minutes'))
			.seconds($clock.attr('data-seconds'));
		var intervalId = workerTimers.setInterval(() => {
			time.add(1, 'second');
			$clock.toggleClass('tock');
			$clock.attr('style', time.format('[--start-hours:]H; [--start-minutes:]m; [--start-seconds:]s;'));
		}, 1000);
	});
};

export default func;
